import ModifySecurityQnsComponent from './ModifySecurityQnsContainer';

export default ModifySecurityQnsComponent;